import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { BUR_KIT, BUR_KIT_IMAGE } from "../constants/content";

export const BurKitSection = () => {
  return (
    <section data-testid="bur-kit-section" className="py-12 md:py-16 bg-[#F5F5F5] overflow-hidden">
      <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
        <span className="text-xs uppercase tracking-[0.2em] font-medium text-gold">
          {BUR_KIT.eyebrow}
        </span>
        <h2 className="font-serif font-medium text-4xl md:text-5xl tracking-tight leading-[1.1] text-[#111111] mt-4">
          {BUR_KIT.heading}
        </h2>
        <p className="text-base md:text-lg text-[#111111]/60 mt-5 leading-relaxed">
          {BUR_KIT.copy}
        </p>

        <motion.div
          initial={{ opacity: 0, rotate: 4, scale: 0.9 }}
          whileInView={{ opacity: 1, rotate: 2, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="relative max-w-sm mx-auto mt-10"
        >
          <div className="relative rounded-2xl overflow-hidden shadow-[0_30px_60px_rgb(0,0,0,0.12)] border border-black/5 bg-white">
            <img
              src={BUR_KIT_IMAGE}
              alt="Advanced Bur Kit, Gladiator Series, by Dr. Moez Khakiani, complimentary for the first 25 buyers"
              className="w-full h-auto object-cover"
              data-testid="bur-kit-image"
              width="900"
              height="667"
              loading="lazy"
            />
          </div>
          <div aria-hidden="true" className="absolute -bottom-6 -left-6 w-32 h-32 rounded-full bg-[#8FA5C7]/25 blur-2xl" />
        </motion.div>

        <ul className="mt-10 space-y-4 text-left max-w-md mx-auto">
          {BUR_KIT.points.map((point, i) => (
            <motion.li
              key={point}
              data-testid={`bur-kit-point-${i}`}
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.5 }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="flex items-start gap-3.5"
            >
              <CheckCircle2 className="h-5 w-5 shrink-0 mt-0.5 text-gold" strokeWidth={2} />
              <span className="text-base text-[#111111]/80 leading-relaxed">{point}</span>
            </motion.li>
          ))}
        </ul>
      </div>
    </section>
  );
};
